export default "__VITE_ASSET__VCEFV7$p__"